export { default as DetailsNavigation } from './DetailsNavigation';
